import { render, staticRenderFns } from "./pojecthomepage.vue?vue&type=template&id=1e5d9d4a&scoped=true&"
import script from "./pojecthomepage.js?vue&type=script&lang=js&"
export * from "./pojecthomepage.js?vue&type=script&lang=js&"
import style0 from "./pojecthomepage.vue?vue&type=style&index=0&id=1e5d9d4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5d9d4a",
  null
  
)

export default component.exports